import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

export interface StatItem {
  label: string;
  value: string | number;
}

export interface StatsRowProps {
  stats: StatItem[];
}

export function StatsRow({ stats }: StatsRowProps) {
  return (
    <View style={styles.statsRow}>
      {stats.map((stat, index) => (
        <StatCard key={index} label={stat.label} value={stat.value} />
      ))}
    </View>
  );
}

function StatCard({ label, value }: StatItem) {
  const { colors } = useTheme();
  return (
    <View style={[styles.statCard, { backgroundColor: colors.backgroundSecondary }]}>
      <ThemedText style={{ fontSize: 18, fontWeight: "700" }}>{value}</ThemedText>
      <ThemedText style={{ fontSize: 11, opacity: 0.6 }}>{label}</ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  statsRow: {
    flexDirection: "row",
    gap: 8,
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  statCard: {
    flex: 1,
    padding: 12,
    borderRadius: 8,
    alignItems: "center",
    gap: 2,
  },
});
